// extracted by mini-css-extract-plugin
export default {"categories_container":"GroceryListCategories_categories_container__TZeru","date_range":"GroceryListCategories_date_range__vLX1L"};